import React from 'react';

export default function Planos() {
  return (
    <div className='container-box'>
      <h5>Planos</h5>
      <span className='title-describe'>Gerencie seu plano contratado.</span>
      <hr />
      <div className="row text-center">

        <div className={'col-md-12 mb-4'}>
          <button
            type="button"
            className='btn btn-lg btn-block btn-secundary'
            onClick={() => window.open('https://sindicantedigital.com/#contato', '_blank')}
          >Entre em contato para mudar o plano</button>
        </div>
        <CardPrice title="Free Individual">
          <div className="card-body">
            <p>Ideal para começar: <strong>5 processos mensais gratuitos</strong></p>
            <p><strong>Investimento: </strong>Grátis</p>
            <p><strong>Vantagem: </strong>Teste todas as funcionalidades sem nenhum custo e veja como nossa plataforma pode transformar suas investigações.</p>
          </div>
        </CardPrice>

        <CardPrice title="Básico Individual">
          <div className="card-body text-left">
            <p>Para pequenas demandas: <strong>20 processos mensais</strong></p>
            <p><strong>Investimento: </strong><h4 >R$ 270,00<small className="text-muted">/ mês</small></h4></p>
            <p><strong>Vantagem: </strong>Perfeito para profissionais com um fluxo regular de processos, oferecendo uma solução econômica para melhorar a eficiência.</p>
          </div>
        </CardPrice>

        <CardPrice title="Intermediário Individual">
          <div className="card-body text-left">
            <p>Para volume médio: <strong>50 processos mensais</strong></p>
            <p><strong>Investimento: </strong><h4 >R$ 480,00<small className="text-muted">/ mês</small></h4></p>
            <p><strong>Vantagem: </strong>Teste todas as funcionalidades sem nenhum custo e veja como nossa plataforma pode transformar suas investigações.</p>
          </div>
        </CardPrice>

        <CardPrice title="Avançado Individual">
          <div className="card-body text-left">
            <p>Para volume médio: <strong>120 processos mensais</strong></p>
            <p><strong>Investimento: </strong><h4 >R$ 980,00<small className="text-muted">/ mês</small></h4></p>
            <p><strong>Vantagem: </strong>Teste todas as funcionalidades sem nenhum custo e veja como nossa plataforma pode transformar suas investigações.</p>
          </div>
        </CardPrice>

        <CardPrice title="Plano Empresa">

          <div className="card-body">
            <p>Soluções personalizadas para sua empresa</p>
            <p><strong>Investimento: </strong>Fale com os nossos consultores para um plano customizado</p>
            <p><strong>Vantagem: </strong>Receba uma solução sob medida que atenda às necessidades específicas da sua empresa, com suporte dedicado e recursos avançados.</p>
          </div>

        </CardPrice>
        <div className={'col-md-12 mb-4'}>
          <button
            type="button"
            className='btn btn-lg btn-block btn-secundary'
            onClick={() => window.open('https://sindicantedigital.com/#contato', '_blank')}
          >Entre em contato para mudar o plano</button>
        </div>
      </div>
    </div>
  );
}

export const CardPrice = ({ title, children }: { title: string, children: React.ReactNode }) => {
  return (
    <div className={title == 'Plano Empresa' ? 'col-md-12 mb-4' : 'col-md-6 mb-4'}>
      <div className="card h-100 shadow-sm">
        <div className="card-header bg-primary">
          <h4 className="my-0 font-weight-normal">{title}</h4>
        </div>
        {children}

      </div>
    </div>
  );
};
